import ApiTransitionMaster from "../../../../components/topNavigationComp/masters/apiTransitionMaster/ApiTransitionMaster"

function ApiTransitionMasterPage() {
    return (
        <>
            <ApiTransitionMaster />
        </>
    )
}
export default ApiTransitionMasterPage